// @flow
import * as React from 'react';

// Constants
import { DROPOFF_ROUTE, TRANSPORTATION_ROUTE } from 'constants/routes';
import { NAVIGATION } from 'constants/navigations';
import { TRANSPORTATION } from 'constants/transportation';

// Components
import Button from 'components/atoms/Button';
import Modal from 'components/atoms/Modal';

// Utils
import { isFn } from 'utils/varValidation';

import './ClutchErrorModal.scss';

const ns = 'clutch-error';
const { BACKWARD } = NAVIGATION;
const { LOANER } = TRANSPORTATION;
type Props = {
  intl: Object,
  tryAgainCallback: () => void,
  modalRef: React.Ref<any>,
  goTo: (path: string, direction: string) => void,
  cleanClutchError: () => void,
  cleanDayTimeError: () => void,
  errorLoadingClutchSlots: boolean,
  requestFailure: boolean,
  transportationOption: string,
  setTransportationOption: (transportationOption: string) => void,
  setLoanerNotAvailableError: (errorLoanerNotAvailable: boolean) => void,
  errorLoanerNotAvailable: boolean
};

class ClutchErrorModal extends React.Component<Props> {
  displayDescription() {
    const { intl, requestFailure } = this.props;

    return (
      <div className={`${ns}__description`}>
        {requestFailure
          ? intl.formatMessage({
              id: 'c8.clutch.loaner.currently.unavailable',
              defaultMessage:
                'Loaner is currently unavailable. Please choose a different transportation method'
            })
          : intl.formatMessage({
              id: 'c8.clutch.loaner.not.available',
              defaultMessage:
                'Loaner not available for next 14 days. Search for more availability or choose a different transportation method'
            })}
      </div>
    );
  }

  resetAvailabilityErrors() {
    const { cleanClutchError, cleanDayTimeError } = this.props;

    cleanClutchError();
    cleanDayTimeError();
  }

  render() {
    const {
      intl,
      tryAgainCallback,
      goTo,
      modalRef,
      requestFailure,
      errorLoadingClutchSlots,
      transportationOption,
      setTransportationOption,
      errorLoanerNotAvailable
    } = this.props;
    const isLoanerError =
      transportationOption === LOANER &&
      (errorLoadingClutchSlots || requestFailure || errorLoanerNotAvailable);

    return (
      <Modal
        ref={modalRef}
        size="small"
        showCloseButton={false}
        className={ns}
        title={() => (
          <div className={`${ns}__clutch-modal-title`} tabIndex={0}>
            {isLoanerError
              ? intl.formatMessage({
                  id: 'c8.common.clutch.loaner.not.available',
                  defaultMessage: 'Loaner Not Available'
                })
              : intl.formatMessage({
                  id: 'c8.common.something.went.wrong',
                  defaultMessage: 'Something went wrong'
                })}
          </div>
        )}
        onClose={() => {
          this.resetAvailabilityErrors();
        }}
      >
        {isLoanerError && this.displayDescription()}
        <div className={`${ns}__container`} tabIndex={0} aria-modal={true}>
          {(!isLoanerError || !requestFailure) && (
            <React.Fragment>
              <Button
                className={`${ns}__button`}
                onClick={() => {
                  this.resetAvailabilityErrors();
                  if (isFn(tryAgainCallback)) {
                    tryAgainCallback();
                  }
                }}
              >
                {isLoanerError
                  ? intl.formatMessage({
                      id: 'c8.common.search.additional.dates',
                      defaultMessage: 'Search Additional Dates'
                    })
                  : intl.formatMessage({
                      id: 'c8.common.close',
                      defaultMessage: 'Try again'
                    })}
              </Button>
              <p className={`${ns}__label`}>
                {intl.formatMessage({
                  id: 'c8.common.or',
                  defaultMessage: 'or'
                })}
              </p>
            </React.Fragment>
          )}
          <Button
            buttonTheme="link"
            onClick={() => {
              this.resetAvailabilityErrors();
              !isLoanerError && setTransportationOption('');
              goTo(
                isLoanerError ? TRANSPORTATION_ROUTE : DROPOFF_ROUTE,
                BACKWARD
              );
            }}
          >
            {intl.formatMessage({
              id: 'c8.pick.up.back.to.transportation.options',
              defaultMessage: 'Back to transportation options'
            })}
          </Button>
        </div>
      </Modal>
    );
  }
}

export default ClutchErrorModal;



// WEBPACK FOOTER //
// ./src/components/pages/components/ClutchValet/ClutchError/ClutchErrorModal.js